import type { CellContext } from '@tanstack/react-table';
import { type ChangeEvent, useEffect, useState } from 'react';
import Input from '@/components/UI/Form/Input';

interface TableMeta {
  updateTableData?: (index: number, id: string, value: string) => void;
  editableRowIndex?: number | null;
  setEditableRowIndex?: (index: number | null) => void;
}

const EditableCell = (props: CellContext<any, any>) => {
  const {
    getValue,
    row: { index },
    column: { id },
    table,
  } = props;

  const meta = table.options.meta as TableMeta | undefined;
  const updateTableData = meta?.updateTableData;
  const editableRowIndex = meta?.editableRowIndex;

  const initialValue = getValue();
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState(initialValue);

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateTableData?.(index, id, value);
  };

  // If the initialValue is changed externally, sync it up with our state
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return index === editableRowIndex ? (
    <Input type='text' name={id} value={value} placeholder='e.g. Sage Office' changed={onChange} onBlur={onBlur} maxLength={250} required />
  ) : (
    <p>{value}</p>
  );
};

export default EditableCell;
